import _ from 'lodash';

export function debounceWithCancellation(method, delay = 250) {
  let cancellablePromise;

  return _.debounce((...params) => {
    if (cancellablePromise) cancellablePromise.cancel();

    cancellablePromise = method.apply(undefined, params)
      .then(() => { cancellablePromise = null; });
  }, delay);
}



// WEBPACK FOOTER //
// ./app/utils/promise-utils.js